import WebAdminRouter from "./web/admin";
import WebPrincipalRouter from "./web/principal";
import WebStaffRouter from "./web/staff";
const WebRouter = [
    {
        path: '/web',
        redirect: () => {
            return '/web/staff'
        }
    },
    // {
    //     path: '/web/home',
    //     component: () =>
    //         import ('../views/web/page/home'),
    //     meta: {
    //         title: '首页',
    //         needLogin: false, // 是否需要登录才能访问
    //         isLogin: false // 是否需要登录才能访问
    //     }
    // },
    {
        path: '/web/login',
        component: () =>
            import ('../views/web/login'),
        meta: {
            title: '登录',
            needLogin: false, // 是否需要登录才能访问
            isLogin: true // 是否需要登录才能访问
        }
    },
    {
        path: '/web/help',
        component: () =>
            import ('../views/web/help'),
        meta: {
            title: '帮助中心',
            needLogin: true, // 是否需要登录才能访问
            isLogin: false // 是否需要登录才能访问
        }
    },
    //  超管
    {
        path: '/web/admin',
        component: () =>
            import ('../views/web/home'),
        children: WebAdminRouter,
    },
    //  审批人员
    {
        path: '/web/principal',
        component: () =>
            import ('../views/web/home'),
        children: WebPrincipalRouter,
    },
    //  执行人员
    {
        path: '/web/staff',
        component: () =>
            import ('../views/web/home'),
        children: WebStaffRouter,
    },

]
export default WebRouter